var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { pick } from 'lodash';
var cls = classNames('data-grid-actions-cell');
export var DataGridRowActionsCellDefaultProps = {
  actions: ['delete'],
  iconSize: 20,
  hasTopBorder: false,
  hasLeftBorder: false,
  colors: {
    background: 'subtle-chrome',
    fill: 'strong-chrome'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    padding: 0;\n    width: 10px;\n    border-bottom: 1px solid ", ";\n  "], ["\n    ", ";\n    padding: 0;\n    width: 10px;\n    border-bottom: 1px solid ", ";\n  "])), theme.APPLY_COLORS, theme.COLOR('line-subtle'))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    \n\n    ", "\n    width: 44px;\n\n    user-select: none;\n    height: 100%;\n    padding: 0;\n    flex-direction: row;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  "], ["\n    ", "\n    \n\n    ", "\n    width: 44px;\n\n    user-select: none;\n    height: 100%;\n    padding: 0;\n    flex-direction: row;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  "])), function (_a) {
    var hasTopBorder = _a.hasTopBorder;
    return hasTopBorder && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      min-height: 46px;\n      border-top: 1px solid ", ";\n    "], ["\n      min-height: 46px;\n      border-top: 1px solid ", ";\n    "])), theme.COLOR('line-semi-subtle'));
  }, function (_a) {
    var hasLeftBorder = _a.hasLeftBorder;
    return hasLeftBorder && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-left: 1px solid ", ";\n    "], ["\n      border-left: 1px solid ", ";\n    "])), theme.COLOR('line-semi-subtle'));
  })
});
// -------- Components -------->
var My = {
  NAME: 'DataGridRowActionsCell',
  Container: styled.td(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles)
};
export var DataGridRowActionsCell = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridRowActionsCellDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    actions = componentProps.actions,
    title = componentProps.title,
    hasTopBorder = componentProps.hasTopBorder,
    hasLeftBorder = componentProps.hasLeftBorder,
    colors = componentProps.colors,
    onClick = componentProps.onClick,
    iconSize = componentProps.iconSize;
  var containerColors = pick(colors, ['background']);
  var iconColors = pick(colors, ['fill']);
  return React.createElement(My.Container, {
    onClick: onClick,
    title: title,
    colors: containerColors,
    className: cls.name(className)
  }, React.createElement(My.Layout, {
    hasLeftBorder: hasLeftBorder,
    hasTopBorder: hasTopBorder
  }, actions));
};
DataGridRowActionsCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;